// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Moodboards_MoodTopRow__uBfx8 {
  height: 50px;
  overflow: hidden;
}

.Moodboards_MoodCard__LRRcv {
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Moodboards_MoodCard__LRRcv:hover {
  transform: scale(1.1); 
}

.Moodboards_MoodCard__LRRcv:hover .Moodboards_MoodTop__AcHJX {
  background-color: #000;
}

.Moodboards_MoodTop__AcHJX {
  background-color: #39606e;
  color: #fff;
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Moodboards_White__zvOfA {
  background-color: #030b0b;
}

.Moodboards_Posit__QSTQf {
  font-size: .75rem;
  font-style: italic;
}

.Moodboards_WhiteName__bm7HO {
  color: #fff;
}

.Moodboards_Content33__PWUX4 {
  background-color: #fafafa;
  color: #000;
}

.Moodboards_MoodBackImage__NSdcr {
  background-color: #000;
  border: 10px solid #333;
  border-radius: 25px;
}

.Moodboards_MoodBackImage1__58WHQ {
  background-color: #000;
  border: 5px solid #333;
  border-radius: 25px;
}

.Moodboards_Width3__RxeAa {
  width: 80%;
}

.Moodboards_BreakTitle__Rw34O {
  border-top: 10px solid #e8f0f1;
}

.Moodboards_MoodTop__AcHJX i {
  color: #fff;
}

.Moodboards_DivO__fONtw {
    overflow: hidden;
    max-height: 50px;
  }

.Moodboards_InputBar__02pn\\+ {
background: #ffffff;
border: 1px solid #e0e3eb;
box-sizing: border-box;
border-radius: 20px;
color: #747686;
padding: 0px 10px;
height: 30px !important;
/* text-align: center; */
}

.Moodboards_BoldScene__LASt6 {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.Moodboards_MoodBack__V3VG2 {
  background-color: #fff;
}

.Moodboards_Small__qvrs\\+ {
  font-size: .65rem;
}

.Moodboards_SubTitle__Ql5vf {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Moodboards_Title__t7HUU {
    color: #f5f5f5;
}

.Moodboards_Top__fBBEg {
  background-color: #1ea7ae;
  color: #fff;
  border: 1px solid #fff;
}

.Moodboards_Top__fBBEg:hover {
  background-color: #5de6ed;
  color: #000;
}

.Moodboards_Top__fBBEg i {
  color: #fff;
}

.Moodboards_Top__fBBEg:hover i {
  color: #000;
}

.Moodboards_ImagesLand__pGlq9 {
  object-fit: contain;
  height: 300px;
  width: 100%;
  border-radius: 20px;
}

.Moodboards_iframe__N\\+dYw {
    object-fit: contain; 
    height: 300px;
    width: 100%;
    border-radius: 2px; 
}

.Moodboards_ImagesIndex__JTkV2 {
    object-fit: contain;
    height: 300px;
    width: 100%; 
} 

.Moodboards_FullsizeText__uT0TB {
  color: rgb(36, 184, 184);
  font-style: italic;
  font-size: .70rem;
}

.Moodboards_FullsizeText__uT0TB:hover {
  color: rgb(14, 66, 66);
  cursor: pointer;
}

.Moodboards_BoldTitle__u5m-S {
  font-weight: 700;
  background-color: #d6fcff;
}

.Moodboards_Date__a7Ylg {
  font-size: .7rem;
}

.Moodboards_Icon__YFvzr i {
  font-size: .6rem;
}

.Moodboards_Date2__94tys {
  font-size: .6rem;
}

.Moodboards_Bold__KQZQZ {
  font-weight: 700;
}

.Moodboards_Datetext__7gPbb {
  background-color: #000;
  color: #fff;
}

.Moodboards_DivSize__AkJW7 {
    height: 80px;
    overflow: auto;
} 

.Moodboards_Edit__eEKHv {
  color: rgb(144, 158, 161);
}

@media screen and (min-width: 1800px) {
  .Moodboards_ImagesLand__pGlq9 {
  height: 500px;
  }

  .Moodboards_iframe__N\\+dYw {
  height: 500px;
  }
}

@media screen and (max-width: 780px) {
  .Moodboards_Width3__RxeAa {
    width: 90%;
  }
}

@media screen and (max-width: 600px) {
  .Moodboards_MoodBackImage__NSdcr {
  border: 10px solid #333;
}

.Moodboards_MoodBackImage1__58WHQ {
  border: 5px solid #333;
}
  .Moodboards_MoodTopRow__uBfx8 {
  height: 50px;
  }

  .Moodboards_DivSize__AkJW7 {
    height: 60px;
    overflow: auto;
  }

  .Moodboards_InputBar__02pn\\+ {
    height: 20px !important;
    font-size: .75rem !important;
  }

.Moodboards_Span100__TIF0P {
  font-size: .85rem;
}

p {
    font-size: .75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Moodboards.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EAGE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;AACA,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,mBAAmB;AACnB,cAAc;AACd,iBAAiB;AACjB,uBAAuB;AACvB,wBAAwB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;EACA,aAAa;EACb;;EAEA;EACA,aAAa;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;EACA,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;EACE;EACA,YAAY;EACZ;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;AAEF;EACE,iBAAiB;AACnB;;AAEA;IACI,iBAAiB;EACnB;AACF","sourcesContent":[".MoodTopRow {\n  height: 50px;\n  overflow: hidden;\n}\n\n.MoodCard {\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.MoodCard:hover {\n  -webkit-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1); \n}\n\n.MoodCard:hover .MoodTop {\n  background-color: #000;\n}\n\n.MoodTop {\n  background-color: #39606e;\n  color: #fff;\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.White {\n  background-color: #030b0b;\n}\n\n.Posit {\n  font-size: .75rem;\n  font-style: italic;\n}\n\n.WhiteName {\n  color: #fff;\n}\n\n.Content33 {\n  background-color: #fafafa;\n  color: #000;\n}\n\n.MoodBackImage {\n  background-color: #000;\n  border: 10px solid #333;\n  border-radius: 25px;\n}\n\n.MoodBackImage1 {\n  background-color: #000;\n  border: 5px solid #333;\n  border-radius: 25px;\n}\n\n.Width3 {\n  width: 80%;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.MoodTop i {\n  color: #fff;\n}\n\n.DivO {\n    overflow: hidden;\n    max-height: 50px;\n  }\n\n.InputBar {\nbackground: #ffffff;\nborder: 1px solid #e0e3eb;\nbox-sizing: border-box;\nborder-radius: 20px;\ncolor: #747686;\npadding: 0px 10px;\nheight: 30px !important;\n/* text-align: center; */\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.MoodBack {\n  background-color: #fff;\n}\n\n.Small {\n  font-size: .65rem;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.Title {\n    color: #f5f5f5;\n}\n\n.Top {\n  background-color: #1ea7ae;\n  color: #fff;\n  border: 1px solid #fff;\n}\n\n.Top:hover {\n  background-color: #5de6ed;\n  color: #000;\n}\n\n.Top i {\n  color: #fff;\n}\n\n.Top:hover i {\n  color: #000;\n}\n\n.ImagesLand {\n  object-fit: contain;\n  height: 300px;\n  width: 100%;\n  border-radius: 20px;\n}\n\n.iframe {\n    object-fit: contain; \n    height: 300px;\n    width: 100%;\n    border-radius: 2px; \n}\n\n.ImagesIndex {\n    object-fit: contain;\n    height: 300px;\n    width: 100%; \n} \n\n.FullsizeText {\n  color: rgb(36, 184, 184);\n  font-style: italic;\n  font-size: .70rem;\n}\n\n.FullsizeText:hover {\n  color: rgb(14, 66, 66);\n  cursor: pointer;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.Date {\n  font-size: .7rem;\n}\n\n.Icon i {\n  font-size: .6rem;\n}\n\n.Date2 {\n  font-size: .6rem;\n}\n\n.Bold {\n  font-weight: 700;\n}\n\n.Datetext {\n  background-color: #000;\n  color: #fff;\n}\n\n.DivSize {\n    height: 80px;\n    overflow: auto;\n} \n\n.Edit {\n  color: rgb(144, 158, 161);\n}\n\n@media screen and (min-width: 1800px) {\n  .ImagesLand {\n  height: 500px;\n  }\n\n  .iframe {\n  height: 500px;\n  }\n}\n\n@media screen and (max-width: 780px) {\n  .Width3 {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .MoodBackImage {\n  border: 10px solid #333;\n}\n\n.MoodBackImage1 {\n  border: 5px solid #333;\n}\n  .MoodTopRow {\n  height: 50px;\n  }\n\n  .DivSize {\n    height: 60px;\n    overflow: auto;\n  }\n\n  .InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n  }\n\n.Span100 {\n  font-size: .85rem;\n}\n\np {\n    font-size: .75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MoodTopRow": `Moodboards_MoodTopRow__uBfx8`,
	"MoodCard": `Moodboards_MoodCard__LRRcv`,
	"MoodTop": `Moodboards_MoodTop__AcHJX`,
	"White": `Moodboards_White__zvOfA`,
	"Posit": `Moodboards_Posit__QSTQf`,
	"WhiteName": `Moodboards_WhiteName__bm7HO`,
	"Content33": `Moodboards_Content33__PWUX4`,
	"MoodBackImage": `Moodboards_MoodBackImage__NSdcr`,
	"MoodBackImage1": `Moodboards_MoodBackImage1__58WHQ`,
	"Width3": `Moodboards_Width3__RxeAa`,
	"BreakTitle": `Moodboards_BreakTitle__Rw34O`,
	"DivO": `Moodboards_DivO__fONtw`,
	"InputBar": `Moodboards_InputBar__02pn+`,
	"BoldScene": `Moodboards_BoldScene__LASt6`,
	"MoodBack": `Moodboards_MoodBack__V3VG2`,
	"Small": `Moodboards_Small__qvrs+`,
	"SubTitle": `Moodboards_SubTitle__Ql5vf`,
	"Title": `Moodboards_Title__t7HUU`,
	"Top": `Moodboards_Top__fBBEg`,
	"ImagesLand": `Moodboards_ImagesLand__pGlq9`,
	"iframe": `Moodboards_iframe__N+dYw`,
	"ImagesIndex": `Moodboards_ImagesIndex__JTkV2`,
	"FullsizeText": `Moodboards_FullsizeText__uT0TB`,
	"BoldTitle": `Moodboards_BoldTitle__u5m-S`,
	"Date": `Moodboards_Date__a7Ylg`,
	"Icon": `Moodboards_Icon__YFvzr`,
	"Date2": `Moodboards_Date2__94tys`,
	"Bold": `Moodboards_Bold__KQZQZ`,
	"Datetext": `Moodboards_Datetext__7gPbb`,
	"DivSize": `Moodboards_DivSize__AkJW7`,
	"Edit": `Moodboards_Edit__eEKHv`,
	"Span100": `Moodboards_Span100__TIF0P`
};
export default ___CSS_LOADER_EXPORT___;
